import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import CircleIcon from '@mui/icons-material/Circle';

const colors = ['#D6B981', '#F4E8D1', '#F4E8B1', '#E8C48F', '#D4A76A'];

const PieCard = ({ data = [], title = "Popular Packages" }) => {
  return (
    <Box
      sx={{
        border: 2,
        borderColor: '#CD9D4126',
        borderRadius: '12px',
        bgcolor: 'white',
        display: 'flex',
        minHeight: '330px',
      }}
    >
      <Stack spacing={1} sx={{ mt: 8, ml: 1 }}>
        {data.map((item, index) => (
          <Box
            key={item.label}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <CircleIcon
              sx={{
                fontSize: 10,
                color: colors[index % colors.length],
                
              }}
            />
            <Typography sx={{ml:1}} variant="body2">
              {item.label}: {item.value}
            </Typography>
          </Box>
        ))}
      </Stack>

      <PieChart
        width={230}
        height={300}
        colors={colors}
        series={[
          {
            arcLabel: (item) => item.label,
            arcLabelMinAngle: 35,
            arcLabelRadius: '2%',
            data: data,
          },
        ]}
        sx={{
          [`& .${pieArcLabelClasses.root}`]: {
            fontWeight: 'bold',
            fontSize: '12px',
            backgroundColor:"white"
          },
        }}
        legend={null}
      />
    </Box>
  );
};

export default PieCard;
